import { LoadingButton } from "@mui/lab";
import {
  TextField,
  Box,
  Alert,
  Collapse,
  InputAdornment,
  IconButton,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "../../api/axios";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import useAuth from "../../hooks/useAuth";
import CryptoJS from "crypto-js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import appSettings from "../../../package.json";

function LoginComp() {
  const axiosPrivate = useAxiosPrivate();
  const { setAuth } = useAuth();
  const [account, setAccount] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [validP, setValidP] = useState(true);
  const [validA, setValidA] = useState(true);
  const [loadB, setLoadB] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [uData, setUData] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state && location.state.from && location.state.from.pathname) || "/main";

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const encryptCredentials = () => {
    let regpatt = /[^A-Za-z0-9+/=\s]/g;
    let res =
      localStorage.getItem("deviceId") &&
      localStorage.getItem("deviceId").replace(regpatt, "");

    if (res && res.trim().length < 16) {
      res = res.padStart(16, "0");
    } else if (res && res.trim().length > 16) {
      res = res.substring(0, 16);
    }
    let key = CryptoJS.enc.Utf8.parse(res);
    let iv = CryptoJS.enc.Utf8.parse(res);

    let encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(
        JSON.stringify({ UserName: account, Password: password })
      ),
      key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return encrypted;
  };

  const submit = () => {
    if (password !== "" && account !== "") {
      setLoadB(true);
      let encCredentials = encryptCredentials();
      axios.post("/auth/AuthorizeUser/", encodeURIComponent(encCredentials.toString()),
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
              deviceId: localStorage.getItem("deviceId"),
            },
          }
        )
        .then(function (response) {
          console.log(response);
          setErrorMsg("");
          const accessToken = response.data.accessToken;
          const accountCode = response.data.clientIdentifier;
          const userData = response.data;
          console.log("authorizeuser response", response.data);
          localStorage.setItem("driverPoiSettings", "Not Set");
          setAuth({ accountCode, accessToken, userData });
          setUData(response.data );
          // setLoadB(false);
          // navigate(from, { replace: true });
        })
        .catch(function (error) {
          setAuth({});
          if (error.response.status === 401) {
            setErrorMsg(error.response.data.message || "Account or Password incorrect");
          }
          console.error(error);
          setLoadB(false);
        })
        .finally(function () {
          //setLoadB(false);
        });
    } else {
      setValidP(password !== "");
      setValidA(account !== "");
    }
  };
  const getUserProfile = async (ud) => {
   // console.log("getUserProfile start ud", ud);
    if (ud && (ud.userRight == "UL" || ud.userRight === "V" || !ud.clientId)) {
      setAuth((prev) => {
        return {
          ...prev,
          userProfile: {},
          driverPoiSettings: localStorage.getItem("driverPoiSettings")
        };
      });
      setLoadB(false);
      navigate(from, { replace: true });
      return;
    }
    //console.log("getUserProfile axios");
    let response = await axiosPrivate.get("/Account/GetUserProfile/" + (ud && ud.clientId));
    //console.log("getUserProfile axios response", response);
    if (response != null) {
      let obj = response.data;
      if (typeof response.data === "string") {
        obj = (JSON.parse(response.data)) || {}
      }
      console.log("getUserProfile response obj", obj);
      if (obj != null) {
        // if (obj.hasOwnProperty("web_settings") && obj.hasOwnProperty("miniTrackingBox")) {
        //   changeUserProfileMiniTrackingBox(obj.web_settings.miniTrackingBox === "true" ? true : false);
        // }
        
        setAuth((prev) => {
          return {
            ...prev,
            userProfile: { ...prev.userProfile, ...obj },            
            driverPoiSettings: localStorage.getItem("driverPoiSettings")
          };
        });
        // if (obj.hasOwnProperty("web_settings") && obj.web_settings.hasOwnProperty("miniTrackingBox") && obj.web_settings.miniTrackingBox != "") {
        //   console.log("getUserProfile obj.websettings=", obj.web_settings, obj.web_settings.miniTrackingBox === "true" ? true : false);
        //   setEnableMiniTrackingBox(true); //obj.web_settings.miniTrackingBox === "true" ? true : false
        // }
        //getPoiList(response.data.driver_enroll);
        setLoadB(false);
        navigate(from, { replace: true });
      }
    } else {
      console.log("getUserProfile bad response", response);
      setErrorMsg("Error getting User Profile, please retry");
    }
  };

  React.useEffect(() => {
    sessionStorage.setItem("video_data", null);
    localStorage.setItem("driverPoiSettings", "Not Set");
    setAuth({});
  }, []);
  React.useEffect(() => {   
      console.log("userData changed", uData);
      uData && getUserProfile(uData).catch((err) => {
        console.error("getUserProfile failed", err);
        const status = err?.response?.status;
        const detail = err?.response?.data?.message || err?.message || "unknown";
        setErrorMsg(`Profile load failed (${status ?? "network"}: ${detail}) — please retry`);
        setLoadB(false);
      });
  }, [uData]);
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        backgroundColor: "#f0f2f5",
      }}
    >
      {/* Left panel - brand */}
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          flex: 1,
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(160deg, #2d2d2d 0%, #1a1a1a 100%)",
          color: "white",
          p: 6,
        }}
      >
        <Box sx={{ mb: 5 }}>
          <img src={"images/Altrack Logged in top left.png"} alt="Altrack" style={{ height: "64px", display: "block" }} />
        </Box>
        <Box sx={{ fontSize: "28px", fontWeight: 600, mb: 2, textAlign: "center" }}>
          Fleet Management
        </Box>
        <Box sx={{ fontSize: "15px", color: "rgba(255,255,255,0.55)", textAlign: "center", maxWidth: "320px", lineHeight: 1.7 }}>
          Real-time vehicle tracking, driver management, and comprehensive fleet analytics in one platform.
        </Box>
        <Box
          sx={{
            mt: 6,
            display: "flex",
            gap: 3,
          }}
        >
          {["Tracking", "Reports", "API"].map((f) => (
            <Box
              key={f}
              sx={{
                px: 2,
                py: 0.75,
                border: "1px solid rgba(0,188,212,0.4)",
                borderRadius: "20px",
                fontSize: "12px",
                color: "#00bcd4",
                letterSpacing: "0.5px",
              }}
            >
              {f}
            </Box>
          ))}
        </Box>
      </Box>

      {/* Right panel - login form */}
      <Box
        sx={{
          width: { xs: "100%", md: "420px" },
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          p: { xs: 4, md: 6 },
          backgroundColor: "white",
          boxShadow: "-4px 0 24px rgba(0,0,0,0.08)",
        }}
      >
        {/* Mobile logo */}
        <Box sx={{ display: { xs: "flex", md: "none" }, justifyContent: "center", mb: 4, bgcolor: "#1a1a1a", borderRadius: "10px", p: 2 }}>
          <img src={"images/Altrack Logged in top left.png"} alt="Altrack" style={{ height: "48px" }} />
        </Box>

        <Box sx={{ mb: 4 }}>
          <Box sx={{ fontSize: "24px", fontWeight: 700, color: "#1a1a1a", mb: 0.5 }}>
            Welcome back
          </Box>
          <Box sx={{ fontSize: "14px", color: "#6b7280" }}>
            Sign in to your account to continue
          </Box>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            required
            fullWidth
            size="small"
            error={!validA}
            label="Account Code"
            helperText={validA ? "" : "Account code is required"}
            onChange={(e) => setAccount(e.target.value)}
            onKeyUp={(e) => { if (e.key === "Enter") submit(); }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": { borderColor: "#00bcd4" },
              },
              "& label.Mui-focused": { color: "#00bcd4" },
            }}
          />
          <TextField
            required
            fullWidth
            size="small"
            error={!validP}
            type={showPassword ? "text" : "password"}
            value={password}
            label="Password"
            helperText={validP ? "" : "Password is required"}
            onChange={(e) => setPassword(e.target.value)}
            onKeyUp={(e) => { if (e.key === "Enter") submit(); }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": { borderColor: "#00bcd4" },
              },
              "& label.Mui-focused": { color: "#00bcd4" },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    size="small"
                    edge="end"
                  >
                    {showPassword ? (
                      <FontAwesomeIcon icon="eye-slash" />
                    ) : (
                      <FontAwesomeIcon icon="eye" />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <LoadingButton
          fullWidth
          loading={loadB}
          variant="contained"
          onClick={submit}
          sx={{
            mt: 3,
            py: 1.2,
            borderRadius: "8px",
            backgroundColor: "#2d2d2d",
            textTransform: "none",
            fontSize: "15px",
            fontWeight: 600,
            letterSpacing: "0.3px",
            "&:hover": { backgroundColor: "#00bcd4" },
          }}
        >
          Sign In
        </LoadingButton>

        <Collapse in={errorMsg !== ""} sx={{ mt: 2 }}>
          <Alert severity="error" sx={{ borderRadius: "8px" }}>{errorMsg}</Alert>
        </Collapse>

        <Box sx={{ mt: "auto", pt: 4, textAlign: "center", fontSize: "12px", color: "#9ca3af" }}>
          {`Version ${appSettings.version}`}
        </Box>
      </Box>
    </Box>
  );
}

export default LoginComp;
